module.exports = __webpack_public_path__ + "aa21bed2d5b135bffa1730e94367ec24.webp";